import commonRegion from './locality-common-region';
var LocalityCommonDistrict = {
  GREATER_QUEANBEYAN: {
    id: 2131,
    type: 'DISTRICT',
    name: 'Greater Queanbeyan',
    slug: 'greater-queanbeyan-queanbeyan-region-nsw',
    parent: commonRegion.QUEANBEYAN,
    metaData: {
      state: 'NSW'
    },
    districtId: 2131,
    region: commonRegion.QUEANBEYAN
  },
  YASS_VALLEY: {
    id: 2431,
    type: 'DISTRICT',
    name: 'Yass Valley',
    slug: 'yass-valley-southern-tablelands-nsw',
    parent: commonRegion.SOUTHERN_TABLELANDS,
    metaData: {
      state: 'NSW'
    },
    districtId: 2431,
    region: commonRegion.SOUTHERN_TABLELANDS
  }
};
export default LocalityCommonDistrict;